import React from 'react';
import { useParams } from 'react-router';

import { ProcessDetailsTasks } from '@/views/processesDetails/components/tasks/ProcessDetailsTasks.comp.tsx';

export const ProcessDetailsTasksTab: React.FC = () => {
  const { processId } = useParams();

  if (!processId) {
    return null;
  }

  return <ProcessDetailsTasks processId={processId} />;
};
